import actions from './actions'

const initialState = {
  list: [], // All roles
  selected: null, // Currently selected role for editing
  permissions: [], // Permissions assigned to selected role
  userRoles: [], // Roles assigned to selected user
  loading: false,
  error: null,
  saveSuccess: false,
}

export default function rolesReducer(state = initialState, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        error: null,
      }

    case actions.FETCH_ROLES_RECEIVED:
      return {
        ...state,
        list: action.payload || [],
        loading: false,
      }

    case actions.CREATE_ROLE_RECEIVED:
      return {
        ...state,
        list: [...state.list, action.payload],
        loading: false,
        saveSuccess: true,
      }

    case actions.FETCH_ROLE_RECEIVED:
      return {
        ...state,
        selected: action.payload,
        loading: false,
      }

    case actions.UPDATE_ROLE_RECEIVED:
      return {
        ...state,
        list: state.list.map(role =>
          role.id === action.payload.id ? action.payload : role
        ),
        selected: action.payload,
        loading: false,
        saveSuccess: true,
      }

    case actions.DELETE_ROLE_RECEIVED:
      return {
        ...state,
        list: state.list.filter(role => role.id !== action.payload),
        selected: null,
        loading: false,
        saveSuccess: true,
      }

    case actions.FETCH_ROLE_PERMISSIONS_RECEIVED:
      return {
        ...state,
        permissions: action.payload || [],
        loading: false,
      }

    case actions.ASSIGN_PERMISSION_TO_ROLE_RECEIVED:
      return {
        ...state,
        permissions: [...state.permissions, action.payload],
        loading: false,
        saveSuccess: true,
      }

    case actions.REMOVE_PERMISSION_FROM_ROLE_RECEIVED:
      return {
        ...state,
        permissions: state.permissions.filter(
          p => !(p.roleId === action.payload.roleId && p.permissionId === action.payload.permissionId)
        ),
        loading: false,
        saveSuccess: true,
      }

    // User-Role management
    case actions.FETCH_USER_ROLES_RECEIVED:
      return {
        ...state,
        userRoles: action.payload || [],
        loading: false,
      }

    case actions.ASSIGN_ROLE_TO_USER_RECEIVED:
      return {
        ...state,
        userRoles: [...state.userRoles, action.payload],
        loading: false,
        saveSuccess: true,
      }

    case actions.REMOVE_ROLE_FROM_USER_RECEIVED:
      return {
        ...state,
        userRoles: state.userRoles.filter(
          ur => !(ur.userId === action.payload.userId && ur.roleId === action.payload.roleId)
        ),
        loading: false,
        saveSuccess: true,
      }

    case actions.RESPONSE_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    default:
      return state
  }
}
